import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Modal } from 'react-bootstrap';
import { Trans } from "react-i18next";

export interface ConfirmModalProps {
    show: boolean;
    setShow: (value: boolean) => void;
    handleConfirm: () => void;
    valueSearch?: any;
    title: string;
    message: string;
    onClose: () => void;
}


export const ConfirmModal: React.FC<ConfirmModalProps> = (props : ConfirmModalProps) => {

  return (        
    <Modal show={props.show} onHide={props.onClose}>
    <Modal.Header closeButton>
      <Modal.Title>
        <Trans>{props.title}</Trans>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Trans>{props.message}</Trans>
      <p className="center">
        <b> {props.valueSearch?.Description}</b>
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button themeColor="secondary" onClick={props.onClose}>
        <Trans>general.cancel</Trans>
      </Button>
      <Button themeColor="primary" onClick={props.handleConfirm}>
        <Trans>general.ok</Trans>
      </Button>
    </Modal.Footer>
    </Modal>
    );
};  